import axios from 'axios';

import Api from 'client/api/v2/Api';

class RecommendationApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2/recommendations';
  }

  fetch() {
    return this.initialize()
      .then(() => axios.get(this.baseUrl));
  }
}

export default new RecommendationApi();
